import { apiUrlPrefix } from "../../../config";

  const leaveDiscussion = async (chatId) => {
    const apiUrl = apiUrlPrefix + 'Discussion/leaveDiscussion';

    const response = await fetch(apiUrl, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Users: [localStorage.getItem('userId')],
        Id: chatId,
      }),
    });

    if (!response.ok) {
      if (response.status === 403) {
        throw new Error('Unable to leave discussion.');
      }
      throw new Error('Network response was not ok');
    }
    return response.status;
  };

  export default leaveDiscussion;